// extracted by mini-css-extract-plugin
export default {"wrap":"wrap--svtTT","input":"input--gHq4J","img":"img--YCmWf"};